<div class="container my-4" *transloco="let t">
  @if (failure(); as failed) {
    <div class="alert alert-warning" role="alert">{{ t(failed.translationKey) }}</div>
  } @else if (loading() && !input()) {
    <multisite-loader-globe-animation-detail [width]="100" [height]="100"></multisite-loader-globe-animation-detail>
  } @else if (input(); as current) {
    @if (!delivery()) {
      <div class="alert alert-info" role="alert">
        {{ t('inputs.not_yours_yet') }}
        <a class="ms-1" [routerLink]="['/contributions/inputs', current.slug]">{{ t('inputs.see_the_input') }}</a>
      </div>
    } @else if (delivery(); as mine) {
      <div class="row">
        <div class="col-lg-8">
          <p class="mb-3">
            <a [routerLink]="['/contributions/inputs', current.slug]">{{ t('inputs.see_the_input') }}</a>
            @if (current.ideas.length) {
              <span class="text-muted ms-2">{{ t('inputs.helps_with') }}:</span>
              @for (idea of current.ideas; track idea.slug; let last = $last) {
                <a class="ms-1" [routerLink]="['/ideas', idea.slug]">{{ idea.name }}</a>@if (!last) {,}
              }
            }
          </p>

          @if (current.instructions.particular.length) {
            <h2 class="h5">{{ t('inputs.instructions_particular') }}</h2>
            @for (instruction of current.instructions.particular; track $index) {
              @if (instruction.s) {
                <p class="fw-semibold mb-1">{{ instruction.s }}</p>
              }
              @if (instruction.m) {
                <div [innerHTML]="instruction.m | insightMarkdown"></div>
              }
            }
          }

          <div class="mt-4">
            <multisite-delivery-conversation
              [deliveryId]="mine.id"
              [canPost]="!handedIn()"
              titleTranslationKey="inputs.your_feedback"
              descriptionTranslationKey="inputs.feedback_help"
              translationScope="inputs">
            </multisite-delivery-conversation>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="card">
            <div class="card-body">
              <p class="mb-2">
                <span class="text-muted">{{ t('inputs.your_work') }}:</span>
                @if (myState(); as state) {
                  <span class="badge badge-pill ms-1" [class]="state.badgeClasses">
                    <i [class]="state.iconClasses" aria-hidden="true"></i>
                    {{ t(state.translationKey) }}
                  </span>
                }
              </p>

              @if (handedIn()) {
                <p class="mb-0">{{ t('inputs.handed_in') }}</p>
              } @else {
                <button type="button" class="btn btn-primary w-100" [disabled]="handingIn()" (click)="handIn()">
                  {{ t('inputs.hand_in') }}
                </button>
                <p class="small text-muted mt-2 mb-0">{{ t('inputs.hand_in_help') }}</p>
              }

              @if (actionFailure(); as failed) {
                <div class="alert alert-danger mt-3 mb-0" role="alert">{{ t(failed.translationKey) }}</div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
